module.exports = __webpack_public_path__ + "img/cancel.b6512207.svg";